/**
 * Environment-aware logger utility
 * - debug/info: Only active in development
 * - warn/error: Always active
 * - Never logs sensitive data (tokens, emails, phone numbers)
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logger utility with environment-based logging
 */
export const logger = {
  /**
   * Debug logs - only in development
   */
  debug: (...args) => {
    if (isDevelopment) {
      // console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Info logs - only in development
   */
  info: (...args) => {
    if (isDevelopment) {
      // console.info('[INFO]', ...args);
    }
  },

  /**
   * Warning logs - always active
   */
  warn: (...args) => {
    // console.warn('[WARN]', ...args);
  },

  /**
   * Error logs - always active
   */
  error: (...args) => {
    // console.error('[ERROR]', ...args);
  }
};

/**
 * Sanitize data to remove sensitive information before logging
 * @param {any} data - Data to sanitize
 * @returns {any} Sanitized data
 */
export const sanitizeForLogging = (data) => {
  if (!data || typeof data !== 'object') {
    return data;
  }

  const sensitiveKeys = [
    'token', 'authToken', 'password', 'password_confirmation',
    'email', 'phone', 'telephone', 'mobile', 'pin', 'pincode',
    'creditCard', 'cardNumber', 'cvv', 'cvc', 'accessKey', 'access_key'
  ];

  const sanitized = Array.isArray(data) ? [...data] : { ...data };

  for (const key in sanitized) {
    const lowerKey = key.toLowerCase();
    if (sensitiveKeys.some(sk => lowerKey.includes(sk))) {
      sanitized[key] = '[REDACTED]';
    } else if (typeof sanitized[key] === 'object' && sanitized[key] !== null) {
      sanitized[key] = sanitizeForLogging(sanitized[key]);
    }
  }

  return sanitized;
};

export default logger;

